<template>
  <div class="legal-page">
    <header class="legal-header">
      <button type="button" class="legal-back" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </button>
      <h1>隐私政策</h1>
    </header>
    <article class="legal-body">
      <p class="legal-meta">更新日期：2026 年 4 月 10 日 · 生效日期：2026 年 4 月 10 日</p>
      <p class="legal-lead">
        Ez-Insight（下称「我们」）重视您的个人信息与隐私保护。本政策说明我们如何收集、使用、存储与保护您的信息。使用本服务即表示您理解并同意本政策；若不同意，请停止使用。
      </p>

      <section>
        <h2>一、我们收集的信息</h2>
        <p>
          1.1 <strong>账号信息：</strong>您注册、登录时提供的账号名、密码（我们通常仅存储加密后的摘要或交由服务端安全处理）等。<br>
          1.2 <strong>您主动提供的内容：</strong>例如您粘贴的视频链接、输入的待总结文本、笔记内容等，用于完成总结与存储功能。<br>
          1.3 <strong>设备与日志信息：</strong>为保障安全与服务质量，我们可能收集设备型号、浏览器类型、访问时间、操作日志、IP 地址等（以实际系统实现为准）。<br>
          1.4 <strong>Cookie 与同类技术：</strong>用于保持登录状态、偏好设置等，详见下文说明。
        </p>
      </section>

      <section>
        <h2>二、我们如何使用信息</h2>
        <p>
          2.1 提供、维护与改进本服务（如生成总结、列表展示、任务状态查询等）。<br>
          2.2 身份验证、安全防范、欺诈监测与故障排查。<br>
          2.3 遵守法律法规、响应监管机关或司法机关的合法要求。<br>
          2.4 在获得您同意或法律允许的其他情形下使用。
        </p>
      </section>

      <section>
        <h2>三、存储、共享与转让</h2>
        <p>
          3.1 我们一般在中华人民共和国境内存储所收集的信息；如需跨境，将依法履行评估、告知与同意等义务。<br>
          3.2 我们不会向第三方出售您的个人信息。仅在以下情形可能共享：经您明确同意；法律法规要求；与授权合作伙伴共享且其受保密与安全义务约束（如云主机、短信/邮件服务商等，以实际为准）。<br>
          3.3 发生合并、收购或资产转让时，如涉及个人信息转移，我们将要求新的持有方继续受本政策约束。
        </p>
      </section>

      <section>
        <h2>四、安全与保留期限</h2>
        <p>
          4.1 我们采取合理的技术与管理措施保护信息安全，但无法保证绝对安全，请您妥善保管账号。<br>
          4.2 我们仅在实现本政策所述目的所必需的期限内保留信息，除非法律要求更长保留期。超期后将删除或匿名化处理。
        </p>
      </section>

      <section>
        <h2>五、您的权利</h2>
        <p>
          在法律规定的范围内，您可查阅、更正、删除您的个人信息，撤回同意、注销账号或获取副本。您可通过产品内提供的入口或联系我们行使权利。我们将在合理期限内答复。
        </p>
      </section>

      <section>
        <h2>六、未成年人保护</h2>
        <p>
          若您为未成年人，请在监护人指导下阅读本政策并使用服务。我们不会主动收集未成年人的个人信息；若发现已收集，将尽快删除。
        </p>
      </section>

      <section>
        <h2>七、政策更新</h2>
        <p>
          我们可能适时修订本政策，并通过站内公告、弹窗等显著方式提示。重大变更将重新征得您的同意（如法律要求）。请您定期查阅更新后的版本。
        </p>
      </section>

      <section>
        <h2>八、联系我们</h2>
        <p>
          如您对本政策有任何疑问、投诉或建议，请通过产品内联系方式与我们沟通。本初版为占位说明，正式对外前请由法务审核并替换为最终文本。
        </p>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/login')
      }
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #faf8f5;
  color: #0a1c44;
  padding: env(safe-area-inset-top, 0px) max(16px, env(safe-area-inset-right, 0px))
    env(safe-area-inset-bottom, 0px) max(16px, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
}

.legal-header {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0 16px;
  background: linear-gradient(180deg, #faf8f5 85%, transparent);
}

.legal-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  background: #fff;
  color: #4253ff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(10, 28, 68, 0.08);
}

.legal-header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.legal-body {
  max-width: 640px;
  margin: 0 auto;
  padding-bottom: 32px;
  font-size: 14px;
  line-height: 1.75;
  color: #3d4f6f;
}

.legal-meta {
  font-size: 12px;
  color: #8b95a8;
  margin: 0 0 16px;
}

.legal-lead {
  margin: 0 0 24px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(10, 28, 68, 0.06);
  color: #4f6188;
}

.legal-body section {
  margin-bottom: 22px;
}

.legal-body h2 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: #0a1c44;
}

.legal-body p {
  margin: 0;
}
</style>
